import { render } from "./OrderDoc.vue?vue&type=template&id=3450b88a"
import script from "./OrderDoc.vue?vue&type=script&lang=js"
export * from "./OrderDoc.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__